import { Modal, ModalProvider } from '@joor/design-system'

import usePortal from 'hooks/usePortal'

import { StyledActions, StyledContent } from './CancelOrderModal'

type OrderErrorModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
}

const OrderErrorModal = ({ isOpen, setOpen }: OrderErrorModalProps) => {
  const Portal = usePortal()
  return (
    <Portal>
      <ModalProvider>
        <Modal
          isOpen={isOpen}
          onClose={(): void => setOpen(false)}
          title={{ text: 'Order contains errors.' }}
          size="medium"
        >
          <Modal.Content>
            <StyledContent>
              To move forward, correct errors highlighted on the overview tab.
            </StyledContent>
          </Modal.Content>
          <StyledActions>
            <Modal.CloseButton>Go Back</Modal.CloseButton>
          </StyledActions>
        </Modal>
      </ModalProvider>
    </Portal>
  )
}

export default OrderErrorModal
